<template>
  <div class="bg">
    <top-ope />
    <div class="page">
      <div class="layout">
        <Sider :style="{ height: '100%', left: 0, overflow: 'auto', width: '100%', maxWidth: '100%', minWidth: '200px', backgroundColor: 'white' }">
          <div class="user_info">
            <Icon type="ios-contact" class="user_list"></Icon>
            <span class="username" style="color: #333;font-size: 20px;">{{username}}</span>
          </div>
          <Menu :theme="theme" :active-name="isSelect" :open-names="isOpen" @on-select="toPage">
            <MenuItem name="upgrade_management" v-if="authList.indexOf('001000') !== -1">
              <Icon type="android-folder" class="menu_icon"></Icon>
              设备管理
            </MenuItem>
            <MenuItem name="version_management" v-if="authList.indexOf('002000') !== -1">
              <Icon type="connection-bars" class="menu_icon"></Icon>
              版本管理
            </MenuItem>
            <!--<MenuItem name="user_management" v-if="authList.indexOf('003000') !== -1">-->
              <!--<Icon type="person" class="menu_icon"></Icon>-->
              <!--用户管理-->
            <!--</MenuItem>-->
            <MenuItem name="config_management" v-if="authList.indexOf('004000') !== -1">
              <Icon type="gear-a" class="menu_icon"></Icon>
              配置管理
            </MenuItem>
            <MenuItem name="log" v-if="authList.indexOf('005000') !== -1">
              <Icon type="ios-calendar-outline" class="menu_icon"></Icon>
              操作日志
            </MenuItem>
            <Submenu name="2" v-if="(authList.indexOf('006000') !== -1) || (authList.indexOf('007000') !== -1) || (authList.indexOf('008000') !== -1)">
              <template slot="title">
                <Icon type="settings" class="menu_icon"></Icon>
                出厂配置
              </template>
              <MenuItem name="factory_allocation" class="pd75" v-if="authList.indexOf('006000') !== -1"> MAC配置 </MenuItem>
              <MenuItem name="production_bath" class="pd75" v-if="authList.indexOf('007000') !== -1">生产批次</MenuItem>
              <MenuItem name="firmware_version" class="pd75" v-if="authList.indexOf('008000') !== -1">固件版本</MenuItem>
              <MenuItem name="product_model" class="pd75" v-if="authList.indexOf('013003') !== -1">产品型号</MenuItem>
            </Submenu>
            <Submenu name="3" v-if="(authList.indexOf('009000') !== -1) || (authList.indexOf('010000') !== -1) || (authList.indexOf('011000') !== -1)">
              <template slot="title">
                <Icon type="briefcase" class="menu_icon"></Icon>
                出入库管理
              </template>
              <MenuItem name="cooperative_partner" class="pd75" v-if="authList.indexOf('009000') !== -1">合作伙伴</MenuItem>
              <MenuItem name="business_management" class="pd75" v-if="authList.indexOf('010000') !== -1">商户管理</MenuItem>
              <MenuItem name="warehouse_record" class="pd75" v-if="authList.indexOf('011000') !== -1">出入库记录</MenuItem>
            </Submenu>
            <Submenu name="4" v-if="(authList.indexOf('009000') !== -1) || (authList.indexOf('010000') !== -1) || (authList.indexOf('011000') !== -1)">
              <template slot="title">
                <Icon type="ios-people" class="menu_icon"></Icon>
                账户配置
              </template>
              <MenuItem name="account_management" class="pd75" v-if="authList.indexOf('009000') !== -1">用户管理</MenuItem>
              <MenuItem name="role_management" class="pd75" v-if="authList.indexOf('010000') !== -1">角色管理</MenuItem>
            </Submenu>

            <MenuItem name="query_short" >
              <Icon type="ios-search" class="menu_icon"></Icon>
              简称查询
            </MenuItem>

            <MenuItem name="query_device" >
              <Icon type="ios-search" class="menu_icon"></Icon>
              设备查询
            </MenuItem>
          </Menu>
        </Sider>
      </div>
      <div class="right">
        <router-view class="view2" />
      </div>
    </div>
    <div class="copyright">
      Copyright © 2017，Damai-IoT，All Rights Reserved | 浙ICP备18001529号
    </div>
  </div>
</template>

<script>
import TopOpe from '../top-ope/top-ope'
import {getAuthStr} from '../../util/bus'

export default {
  components: {TopOpe},
  name: 'nav-list',
  props: {
    openName: Array
  },
  data () {
    return {
      authList: '',
      isSelect: '',
      isOpen: [],
      username: '',
      theme: 'light'
    }
  },
  created () {
    this.authList = getAuthStr()
    let navListState = window.sessionStorage.getItem('navListState')
    if (navListState === 'factory_allocation' || navListState === 'production_bath' || navListState === 'firmware_version') {
      this.isOpen = ['2']
    }
    if (navListState === 'cooperative_partner' || navListState === 'business_management' || navListState === 'warehouse_record') {
      this.isOpen = ['3']
    }
    if (navListState === 'account_management' || navListState === 'role_management') {
      this.isOpen = ['4']
    }
    this.username = window.sessionStorage.getItem('theDevUserName')
  },
  mounted () {
    let navListState = window.sessionStorage.getItem('navListState')
    if (navListState) {
      this.isSelect = navListState
    }
  },
  methods: {
    toPage (name) {
      window.sessionStorage.setItem('navListState', name)
      this.$router.push({
        path: '/' + name
      })
    }
  },
  watch: {
    $route (v) {
      setTimeout(() => {
        let navListState = window.sessionStorage.getItem('navListState')
        if (navListState === 'factory_allocation' || navListState === 'production_bath' || navListState === 'firmware_version') {
          this.isOpen = ['2']
        }
        if (navListState === 'cooperative_partner' || navListState === 'business_management' || navListState === 'warehouse_record') {
          this.isOpen = ['3']
        }
        if (navListState) {
          this.isSelect = navListState
        }
      }, 50)
    }
  }
}
</script>

<style scoped>
  .bg {
    width: 100%;
    height: 100%;
  }
  .page {
    width: 100%;
    height: 89%;
    min-width: 1550px;
    min-height: 707px;
    display: flex;
    justify-content: space-between;
  }
  .layout{
    width: 18%;
    min-width: 200px;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
  }
  .layout
  .user_info{
    padding: 5% 0;
    height: 10%;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }
  .user_list {
    color: #2d8cf0;
    font-size: 40px;
    line-height: 45px;
    margin-left: 20px;
  }
  .username {
    display:inline-block;
    font-size: 24px;
    color: white;
    line-height: 45px;
    vertical-align: top;
    margin-left: 20px;
    max-width: 70%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .menu_icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    text-align: center;
    font-size: 16px;
  }
  .pd75 {
    padding-left: 75px!important;
  }
  .ivu-layout-sider ul {
    width: 100%!important;
    height: 90%;
  }
  .right {
    width: 80%;
    min-width: 1000px;
  }
  .copyright {
    color: #999;
    text-align: center;
    line-height: 50px;
    border-top: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/views/nav-list/nav-list.vue